import axios from 'axios';
import { infoStore, ParticipationStatus } from '../store/infoStore';
import { useCallback } from 'react';
import { createBaseParams, getApiEndPoint } from '../utils';
import { qrStore } from '../store/qrStore';
import { modalStore } from '../store/modalStore';
import { useDateHook } from './useDateHook';

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const eventBase = `${getApiEndPoint()}/api-gateway`;
const API_URL = {
  eventInfo: `${eventBase}/nhapi/tnmt/event`,
  qrHash: `${eventBase}/nhapi/tnmt/event/hash`,
  getTicket: `${eventBase}/neapi/tnmt/event/ticket`,
  agreePrivacy: `${eventBase}/nhapi/tnmt/event/agree`,
};

const ENTRY_GROUP_SRL = 11;

export const useApiHook = () => {
  const { setInfo } = infoStore();
  const { showPrivacyModal } = modalStore();
  const { isOverPrivacyDate } = useDateHook();

  const getEventInfo = useCallback(() => {
    axios
      .post(API_URL.eventInfo, createBaseParams(ENTRY_GROUP_SRL))
      .then((response) => {
        setInfo(response.data.data);
        return response.data.data;
      })
      .then((r) => {
        const userStatus = r.status;
        if (userStatus === ParticipationStatus.NOT_AGREED) {
          // 동의 기간이 지난 경우
          if (isOverPrivacyDate) {
            return;
          }

          showPrivacyModal();
          return;
        }
      })
      .catch((e) => {
        // alert('에러가 발생 했습니다. 잠시 후 다시 시도해 주세요.');
        console.log(e);
        setInfo({
          status: 3,
          ticketCnt: 0,
          ticketNo: null,
        });
      });
  }, [setInfo, showPrivacyModal, isOverPrivacyDate]);

  const getQr = async (tnmtScheduleSrl: number) => {
    try {
      const response = await axios.post(API_URL.qrHash, createBaseParams(11, tnmtScheduleSrl));
      return response.data.data;
    } catch (e) {
      alert('에러가 발생 했습니다. 잠시 후 다시 시도해 주세요.');
      console.log(e);
      return {
        qrHash: '',
        createDate: '',
      };
    }
  };

  const postAgreePrivacy = () => {
    return axios.post(API_URL.agreePrivacy, createBaseParams()).then(() => getEventInfo());
  };

  return { getEventInfo, getQr, postAgreePrivacy };
};
